import { defineMessages } from 'react-intl';

export default defineMessages({
    demoEnvironmentLabel: {
        id: 'anonymous.fnol.header.default.THIS IS NOT PROD environment',
        defaultMessage: 'THIS IS NOT PROD environment'
    }
});
